<template>
  <div>
    <SectionHeader header="Application Review" image="uiw-font-person" :active="makeHeaderActive" />
    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="enable">
      <!-- <p>Please review the application</p>
      <SubHeader header="Entity Details" /> -->

      <p>Before submitting your application, please review the details provided and ensure they are correct.</p>
      <SubHeader header="Business Details" />
      <div class="row div-padding">
        <div class="col-6">Legal Company Name</div>
        <div class="col-6 text-bold">
          {{ entityDetails ? entityDetails.entityName : '' }}
        </div>
        <div class="col-6">ABN</div>
        <div class="col-6 text-bold">
          {{ entityDetails ? entityDetails.abn : '' }}
        </div>
        <div class="col-6">Company Legal Address</div>
        <div class="col-6 text-bold">
          {{ businessDetails && businessDetails.entityDetails ? businessDetails.entityDetails.companyLegalAddress : '' }}
        </div>
        <div class="col-6" v-if="businessDetails && businessDetails.entityDetails && !businessDetails.entityDetails.tradingAddressSame">
          Trading Address
        </div>
        <div
          class="col-6 text-bold"
          v-if="businessDetails && businessDetails.entityDetails && !businessDetails.entityDetails.tradingAddressSame"
        >
          {{ businessDetails && businessDetails.entityDetails ? businessDetails.entityDetails.tradingAddress : '' }}
        </div>
        <div class="col-6">Company Contact Phone</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.entityDetails.businessContactNumber')">
            {{ businessDetails && businessDetails.entityDetails ? businessDetails.entityDetails.businessContactNumber : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'entityDetails', 'businessContactNumber')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'entityDetails', 'businessContactNumber')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({ required: true, type: 'tel', length: 10 })"
                lazy-rules
                ref="businessDetails-entityDetails-businessContactNumber"
              />
              <button ref="businessDetails-entityDetails-businessContactNumber-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-entityDetails-businessContactNumber-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Company Website</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.entityDetails.businessWebsite')">
            {{ businessDetails && businessDetails.entityDetails ? businessDetails.entityDetails.businessWebsite : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'entityDetails', 'businessWebsite')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'entityDetails', 'businessWebsite')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({})"
                lazy-rules
                ref="businessDetails-entityDetails-businessWebsite"
              />
              <button ref="businessDetails-entityDetails-businessWebsite-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-entityDetails-businessWebsite-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6" v-if="0">Industry Type</div>
        <div class="col-6 text-bold" v-if="0">
          <div v-if="!isEditMode('businessDetails.entityDetails.natureOfBusiness')">
            {{ businessDetails && businessDetails.entityDetails ? businessDetails.entityDetails.natureOfBusiness : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'entityDetails', 'natureOfBusiness')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'entityDetails', 'natureOfBusiness')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({})"
                lazy-rules
                ref="businessDetails-entityDetails-natureOfBusiness"
              />
              <button ref="businessDetails-entityDetails-natureOfBusiness-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-entityDetails-natureOfBusiness-button')"
              />
            </QForm>
          </div>
        </div>
      </div>
      <br />
      <SubHeader header="Business Cashflow Details" />
      <div class="row div-padding">
        <div class="col-6">Annual Revenue</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.annualRevenue')">
            {{ businessDetails ? currencyFormatter(businessDetails.annualRevenue) : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'annualRevenue')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'annualRevenue')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({ required: true, type: 'float' })"
                lazy-rules
                ref="businessDetails-annualRevenue"
              />
              <button ref="businessDetails-annualRevenue-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-annualRevenue-button')"
              />
            </QForm>
          </div>
        </div>
      </div>
      <br />
      <SubHeader header="Other Details" />
      <div class="row div-padding">
        <div class="col-6">Current Fleet Size</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.financeDetails.currentFleetSize')">
            {{ businessDetails && businessDetails.financeDetails ? businessDetails.financeDetails.currentFleetSize : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'financeDetails', 'currentFleetSize')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'financeDetails', 'currentFleetSize')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({ minLength: 1, maxLength: 3, type: 'number' })"
                lazy-rules
                ref="businessDetails-financeDetails-currentFleetSize"
              />
              <button ref="businessDetails-financeDetails-currentFleetSize-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-financeDetails-currentFleetSize-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Number of Employees</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.financeDetails.numberOfEmployees')">
            {{ businessDetails && businessDetails.financeDetails ? businessDetails.financeDetails.numberOfEmployees : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'financeDetails', 'numberOfEmployees')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'financeDetails', 'numberOfEmployees')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="getRules({ minLength: 1, maxLength: 4, type: 'number' })"
                lazy-rules
                ref="businessDetails-financeDetails-numberOfEmployees"
              />
              <button ref="businessDetails-financeDetails-numberOfEmployees-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-financeDetails-numberOfEmployees-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Personal Guarantee</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.financeDetails.personalGuarantee')">
            {{
              businessDetails && businessDetails.financeDetails
                ? capitalizeFirstLetter(businessDetails.financeDetails.personalGuarantee)
                : ''
            }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right; display: none"
              @click="onEdit('businessDetails', 'financeDetails', 'personalGuarantee')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'financeDetails', 'personalGuarantee')">
              <QRadio v-model="localValue" val="yes" label="Yes" />
              <QRadio v-model="localValue" val="no" label="No" />
              <QSpinner ref="businessDetails-financeDetails-personalGuarantee" v-if="fieldLoading" />
              <button ref="businessDetails-financeDetails-personalGuarantee-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-financeDetails-personalGuarantee-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Planning on Growing Fleet</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.financeDetails.purchaseMoreVehicles')">
            {{
              businessDetails && businessDetails.financeDetails
                ? capitalizeFirstLetter(businessDetails.financeDetails.purchaseMoreVehicles)
                : ''
            }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'financeDetails', 'purchaseMoreVehicles')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'financeDetails', 'purchaseMoreVehicles')">
              <QRadio v-model="localValue" val="yes" label="Yes" />
              <QRadio v-model="localValue" val="no" label="No" />
              <QSpinner ref="businessDetails-financeDetails-purchaseMoreVehicles" v-if="fieldLoading" />
              <button ref="businessDetails-financeDetails-purchaseMoreVehicles-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-financeDetails-purchaseMoreVehicles-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Vehicles Required for Fleet Growth</div>
        <div class="col-6 text-bold">
          <div v-if="!isEditMode('businessDetails.financeDetails.howManyVehicles')">
            {{ businessDetails && businessDetails.financeDetails ? businessDetails.financeDetails.howManyVehicles : '' }}
            <i
              class="uiw-font-edit"
              alt="edit"
              title="edit"
              style="cursor: pointer; float: right"
              @click="onEdit('businessDetails', 'financeDetails', 'howManyVehicles')"
            />
          </div>
          <div v-else>
            <QForm @submit.prevent="onSave('businessDetails', 'financeDetails', 'howManyVehicles')">
              <QInput
                class="review-input"
                outlined
                v-model.lazy="localValue"
                :loading="fieldLoading"
                :rules="
                  getRules({
                    required: true,
                    minLength: 1,
                    maxLength: 3,
                    type: 'number'
                  })
                "
                lazy-rules
                ref="businessDetails-financeDetails-howManyVehicles"
              />
              <button ref="businessDetails-financeDetails-howManyVehicles-button" style="display: none" type="submit">Submit</button>
              <i
                class="uiw-font-close"
                alt="cancel"
                title="cancel"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onCancel"
              />
              <i
                class="uiw-font-checkmark"
                alt="save"
                title="save"
                style="cursor: pointer; float: right; margin-top: 5px"
                @click="onImageSave('businessDetails-financeDetails-howManyVehicles-button')"
              />
            </QForm>
          </div>
        </div>
        <div class="col-6">Value of Application</div>
        <div class="col-6 text-bold">
          {{
            businessDetails && businessDetails.financeDetails ? currencyFormatter(businessDetails.financeDetails.valueOfApplication) : ''
          }}
        </div>
      </div>
      <br />
      <SubHeader header="Authorised Officer" />
      <div class="row div-padding">
        <div class="col-6">Name</div>
        <div class="col-6 text-bold">
          {{ primaryApplicant ? primaryApplicant.firstName + ' ' + primaryApplicant.lastName : '' }}
        </div>
        <div class="col-6">Email</div>
        <div class="col-6 text-bold">
          {{ primaryApplicant ? primaryApplicant.email : '' }}
        </div>
        <div class="col-6">Mobile</div>
        <div class="col-6 text-bold">
          {{ primaryApplicant ? primaryApplicant.phone : '' }}
        </div>
      </div>
      <br />
      <SubHeader header="Secondary Authorised Officer" v-if="hasSecondaryApplicant == 'yes'" />
      <div class="row div-padding" v-if="hasSecondaryApplicant == 'yes'">
        <div class="col-6">Name</div>
        <div class="col-6 text-bold">
          {{ secondaryApplicant ? secondaryApplicant.firstName + ' ' + secondaryApplicant.lastName : '' }}
        </div>
        <div class="col-6">Email</div>
        <div class="col-6 text-bold">
          {{ secondaryApplicant ? secondaryApplicant.email : '' }}
        </div>
        <div class="col-6">Mobile</div>
        <div class="col-6 text-bold">
          {{ secondaryApplicant ? secondaryApplicant.phone : '' }}
        </div>
        <div class="col-6">Role</div>
        <div class="col-6 text-bold">
          {{ secondaryApplicant ? capitalizeFirstLetter(secondaryApplicant.applicantType) : '' }}
        </div>
      </div>
      <div class="row items-center">
        <div class="col-1">
          <QCheckbox v-model="form.checked" v-if="form.reviewed" />
        </div>
        <div class="col-11">
          <ul>
            <li style="list-style: none">
              <b>By submitting the application, I:</b>
            </li>
            <li>confirm that all information in this Application is complete and accurate;</li>
            <li>acknowledge that the information I have provided will be relied on by FleetPartners to assess my Application;</li>
            <li>
              acknowledge that I have read the
              <strong>
                <a :href="consentUrl" target="_blank">Privacy Collection Notice</a>
              </strong>
              and agree to the collection, use and storage of my personal information as set out in it; and
            </li>
            <li>
              consent to my information being checked with the document issuer or official record holder via third party systems for the
              purpose of confirming my identity, and to a credit check being performed by a credit reporting agency.
            </li>
          </ul>
        </div>
      </div>
      <div v-if="0">
        <p>--For testing purpose only--</p>
        <QRadio v-model="testingValue" val="accept" label="Accept" />
        <QRadio v-model="testingValue" val="refer" label="Refer" />
      </div>
      <br />
      <br />
      <div class="q-px-md q-py-md text-center">
        <QBtn
          v-if="form.reviewed"
          color="primary"
          type="submit"
          no-caps
          :disable="!form.checked"
          @click="onConfirmHandler"
          :loading="loading"
          >Confirm & Submit</QBtn
        >
        <QBtn v-else color="primary" type="submit" no-caps @click="openReviewPopup">Review Privacy Collection Notice</QBtn>
      </div>
      <QDialog v-model="showConsentPopup" full-width full-height>
        <QCard>
          <iframe :src="consentUrl" style="width: 100%; height: calc(100% - 60px)"></iframe>
          <div class="text-center">
            <QBtn color="primary" no-caps @click="closeReviewPopup()" :loading="loadingConsentBtn">Confirm</QBtn>
          </div>
        </QCard>
      </QDialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { QBtn, QCheckbox, QInput, QForm, QRadio, QSpinner, QDialog, QCard } from 'quasar';
import { Icons } from 'eclipx.ui';
import SectionHeader from '../../components/Atoms/SectionHeader';
import SubHeader from '../../components/Atoms/SubHeader';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';
import MutateSubmitCreditCheck from '../../graphql/mutations/MutateSubmitCreditCheck';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';

export default {
  name: 'ApplicationReview',
  components: {
    SectionHeader,
    SubHeader,
    QBtn,
    QCheckbox,
    QInput,
    QForm,
    QRadio,
    QSpinner,
    QDialog,
    QCard
  },
  props: ['makeHeaderActive', 'enable'],
  mixins: [MyCustomFunctions],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      vehicleApplication: (state) => state.vehicleApplication.vehicleApplication
    }),
    ...mapGetters({
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant',
      whiteLabel: 'theme/getWhitelabel'
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    businessDetails() {
      return this.scoreboard?.businessDetails ? this.scoreboard?.businessDetails : null;
    },
    entityDetails() {
      return this.scoreboard?.entityDetails ? this.scoreboard?.entityDetails : null;
    },
    secondaryApplicant() {
      return this.scoreboard?.secondaryApplicant ? this.scoreboard?.secondaryApplicant : null;
    },
    consentUrl() {
      return 'https://assets.fleetpartners.com.au/legal/documents/FleetPartners-Privacy-Collection-Notice.pdf';
    },
    consentCreated() {
      return this.scoreboard?.primaryApplicant?.privacyConsent ? this.scoreboard?.primaryApplicant?.privacyConsent : null;
    },
    hasSecondaryApplicant() {
      return this.scoreboard?.entityDetails?.hasSecondaryApplicant ? this.scoreboard?.entityDetails?.hasSecondaryApplicant : null;
    },
    privacyPolicy() {
      return this.whiteLabel.privacyPolicy || 'https://eclipxgroup.com/privacy-policy/';
    }
  },
  created() {
    this.editIcon = Icons.evaEdit2;
    this.saveIcon = Icons.evaCheckmarkOutline;
  },
  data: function () {
    return {
      form: {
        reviewed: false,
        checked: false
      },
      showConsentPopup: false,
      loadingConsentBtn: false,
      localField: null,
      localValue: null,
      fieldLoading: false,
      testingValue: 'accept',
      loading: false
    };
  },
  methods: {
    onConfirmHandler: async function () {
      this.loading = true;

      await this.$apollo
        .mutate({
          mutation: MutateSubmitCreditCheck,
          variables: {
            payload: {
              applicationId: this.vehicleApplication.applicationId,
              testingValue: this.testingValue
            }
          }
        })
        .then(async (data) => {
          if (data && data.data && data.data.submitCreditCheck && data.data.submitCreditCheck.result) {
            var resultValue = 'refer';
            if (data.data.submitCreditCheck.result.toLowerCase() === 'approved') resultValue = 'approved';
            else if (data.data.submitCreditCheck.result.toLowerCase() === 'declined') resultValue = 'declined';
            else if (data.data.submitCreditCheck.result === 'secondary_idscan_not_complete') resultValue = 'waiting';

            await this.updateVehicleApplication(resultValue, 'statusCreditCheck');

            if (this.isUserPrimaryApplicant)
              await this.updateVehicleApplication('completed', 'primaryApplicant', 'applicationReviewStatus');

            setTimeout(() => {
              if (resultValue === 'waiting') this.$emit('applicationReviewCreated', 'secondary-not-completed');
              else this.$emit('applicationReviewCreated', 'secondary-completed');
            });
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loading = false;
    },
    isEditMode: function (field) {
      if (this.localField == field) return true;
      else false;
    },
    onEdit: function (firstParam, secondParam, thirdParam = null) {
      if (thirdParam) {
        this.localField = `${firstParam}.${secondParam}.${thirdParam}`;
        this.localValue = this[firstParam][secondParam][thirdParam];
      } else {
        this.localField = `${firstParam}.${secondParam}`;
        this.localValue = this[firstParam][secondParam];
      }
    },
    onSave: async function (firstParam, secondParam, thirdParam = null) {
      this.fieldLoading = true;
      if (thirdParam) {
        const refVal = `${firstParam}-${secondParam}-${thirdParam}`;
        if (
          !(
            refVal === 'businessDetails-financeDetails-personalGuarantee' ||
            refVal === 'businessDetails-financeDetails-purchaseMoreVehicles'
          )
        )
          this.$refs[`${firstParam}-${secondParam}-${thirdParam}`].focus();
        await this.updateVehicleApplication(this.localValue, firstParam, secondParam, thirdParam);
      } else {
        this.$refs[`${firstParam}-${secondParam}`].focus();
        await this.updateVehicleApplication(this.localValue, firstParam, secondParam);
      }
      this.fieldLoading = false;
      this.localField = null;
    },
    onCancel: function () {
      this.localField = null;
    },
    onImageSave: async function (refIdString) {
      this.$refs[refIdString].click();
    },
    openReviewPopup: function () {
      this.showConsentPopup = true;
    },
    closeReviewPopup: async function () {
      this.loadingConsentBtn = true;
      await this.updateVehicleApplication('confirmed', 'primaryApplicant', 'privacyConsent');
      if (this.consentCreated === 'confirmed') {
        this.showConsentPopup = false;
        this.form.reviewed = true;
      }
      this.loadingConsentBtn = false;
    },
    getRules: function (ruleObj) {
      const rules = [];
      const required = ruleObj.required;
      const minLength = ruleObj.minLength;
      const maxLength = ruleObj.maxLength;
      const length = ruleObj.length;
      const type = ruleObj.type;

      if (required) {
        rules.push((val) => {
          if (!val || val == '') {
            return 'Field is required';
          }
          return true;
        });
      }
      if (minLength && minLength > 0) {
        rules.push((val) => {
          if (val && val.length < minLength) {
            return `Field value must have at least ${minLength} letters.`;
          }
          return true;
        });
      }
      if (maxLength && maxLength > 0) {
        rules.push((val) => {
          if (val && val.length > maxLength) {
            return `Field value must have at most ${maxLength} letters.`;
          }
          return true;
        });
      }
      if (length && length > 0) {
        rules.push((val) => {
          if (val && val.length != length) {
            return `Field value length must equal to ${length}`;
          }
          return true;
        });
      }
      if (this.type == 'email') {
        rules.push((val) => {
          if (this.validate && !this.validateEmail(val)) {
            return 'Field needs to be an email address';
          }
          return true;
        });
      }
      if (type == 'tel') {
        rules.push((val) => {
          if (!this.validateTel(val)) {
            return 'Field needs to be a telephone number';
          }
          return true;
        });
      }
      if (type == 'number') {
        rules.push((val) => {
          if (!this.validateTel(val)) {
            return 'Field needs to be digits';
          }
          return true;
        });
      }
      if (type == 'float') {
        rules.push((val) => {
          if (!(this.validateTel(val) || val.includes('.'))) {
            return 'Field needs to be float';
          }
          return true;
        });
      }
      return rules;
    },
    validateEmail: function (email) {
      const re =
        /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(String(email).toLowerCase());
    },
    validateTel: function (phone) {
      const re = /^[+]{0,1}[()0-9 ]*$/;
      return re.test(String(phone));
    },
    currencyFormatter: function (argument) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(argument);
    }
  }
};
</script>
<style lang="sass" scoped>
.text-bold
  font-weight: 700;
  color: $primary;
.div-padding .col-6
  padding: 8px 0px;
</style>
